import { Activity } from '@share/interfaces';
import { EventType } from '@share/enums';
import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import { useHelper } from 'src/hooks';
import { web3 } from '@state/web3';
import dayjs from 'dayjs';
import loadable from '@loadable/component';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const SkeletonImage = loadable(() => import('@com/utils/SkeletonImage'));

interface Props {
  data: Activity;
}

function UserActivityCard(props: Props): JSX.Element {
  /* Define state / hook */

  const { data } = props;
  const { transactionExplorerBaseURL } = web3.useContainer();
  const { getEventName } = useHelper();
  /* Custom Data Object for render or other usages */
  const nft = data?.nft;
  const collection = nft?.collection;
  const chainId = data?.network_chain_id;
  const collectionIdentifier = collection?.custom_url || collection?.address;

  const humanTime = dayjs(Number(data?.datetime_timestamp) * 1000).fromNow();

  const eventIcon: Record<EventType, string> = {
    [EventType.BID]: 'icon-fl-clock',
    [EventType.BID_ACCEPT]: 'icon-fl-check-1',
    [EventType.CANCEL]: 'icon-fl-logout',
    [EventType.LIST]: 'icon-fl-discount',
    [EventType.MINTED]: 'icon-fl-star',
    [EventType.SALE]: 'icon-fl-buy',
    [EventType.TRANSFER]: 'icon-fl-reload',
  };

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <div className="row-12 w-100 d-flex justify-content-center">
      <div
        css={css`
          width: 75%;
          @media (max-width: 1200px) {
            width: 100% !important;
          }
        `}
      >
        <div className="sc-card-activity style1">
          <div className="content">
            <div className="media">
              <SkeletonImage
                alt="NFT Asset"
                ratio={1}
                size={[128]}
                src={nft?.preview || nft?.asset}
                width={120}
              />
            </div>
            <div className="infor">
              <h3>
                <Link
                  to={`/nft/${chainId}/${collectionIdentifier}/${nft?.token_id}`}
                >
                  {nft?.name}
                </Link>
              </h3>
              <div className="status">{getEventName(data?.event_type)}</div>
              <div className="time">
                {data?.transaction_hash?.startsWith('0x') ? (
                  <a
                    href={`${transactionExplorerBaseURL(chainId)}/${
                      data?.transaction_hash
                    }`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {humanTime}
                  </a>
                ) : (
                  <span>{humanTime}</span>
                )}
              </div>
            </div>
          </div>
          <div
            className={`button-active icon ${eventIcon[data?.event_type]}`}
          />
        </div>
      </div>
    </div>
  );
}

export default UserActivityCard;
